export default __webpack_public_path__ + "static/media/Ballroll_00130.44d3c170.png";